import { EERIE } from 'HubStyleTokens/colors';
import UIBadge from 'UIComponents/badge/UIBadge';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import Small from 'UIComponents/elements/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DATASET_BULK_ENROLLMENT } from 'automation-ui-enrollment/constants/Gates';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import useHasListsToolAccess from 'automation-ui-enrollment/hooks/useHasListsToolAccess';
import useHasDatasetsToolAccess from 'automation-ui-enrollment/hooks/useHasDatasetsToolAccess';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ENROLL_FROM_LIST = 'ENROLL_FROM_LIST';
const ENROLL_INDIVIDUAL = 'ENROLL_INDIVIDUAL';
const ENROLL_FROM_TRIGGERS = 'ENROLL_FROM_TRIGGERS';
const ENROLL_CUSTOM = 'ENROLL_CUSTOM';
const ENROLL_FROM_DATASET = 'ENROLL_FROM_DATASET';
const ManualEnrollmentRadioOptions = ({
  objectTypeId,
  selectedOption,
  handleOptionChange,
  canEnrollFromExistingTriggers,
  isEventBasedWorkflow
}) => {
  const hasListsToolAccess = useHasListsToolAccess(objectTypeId);
  const hasDatasetsToolAccess = useHasDatasetsToolAccess();
  const isUngatedForDatasetBulkEnrollment = useIsUngated(DATASET_BULK_ENROLLMENT);
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollmentMethod_cob",
      objectTypeId: objectTypeId
    }),
    children: /*#__PURE__*/_jsxs(UIToggleGroup, {
      className: "m-top-3",
      name: "manual-enroll-radio",
      children: [/*#__PURE__*/_jsxs(_Fragment, {
        children: [isEventBasedWorkflow && canEnrollFromExistingTriggers && /*#__PURE__*/_jsxs(UIRadioInput, {
          "data-test-id": "enabled-enroll-from-triggers-radio-option",
          checked: selectedOption === ENROLL_FROM_TRIGGERS
          // TODO finish implementing onChange
          ,
          onChange: () => {
            handleOptionChange(ENROLL_FROM_TRIGGERS);
          },
          disabled: !canEnrollFromExistingTriggers,
          description: /*#__PURE__*/_jsx(Small, {
            use: "help",
            children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
              baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromTriggers.description_cob",
              objectTypeId: objectTypeId
            })
          }),
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromTriggers.title"
          }), /*#__PURE__*/_jsx(UIIcon, {
            className: "m-left-1",
            name: "dynamicFilter",
            color: EERIE,
            size: 18
          })]
        }), /*#__PURE__*/_jsx(UIRadioInput, {
          checked: selectedOption === ENROLL_CUSTOM
          // TODO finish implementing onChange
          ,
          onChange: () => {
            handleOptionChange(ENROLL_CUSTOM);
          },
          description: /*#__PURE__*/_jsx(Small, {
            use: "help",
            children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
              baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollCustom.description_cob",
              objectTypeId: objectTypeId
            })
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollCustom.title"
          })
        })]
      }), hasListsToolAccess && /*#__PURE__*/_jsx(UIRadioInput, {
        checked: selectedOption === ENROLL_FROM_LIST,
        onChange: () => {
          handleOptionChange(ENROLL_FROM_LIST);
        },
        description: /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
            baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.description_cob",
            objectTypeId: objectTypeId
          })
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.title"
        })
      }), hasDatasetsToolAccess && isUngatedForDatasetBulkEnrollment && /*#__PURE__*/_jsx(UIRadioInput, {
        checked: selectedOption === ENROLL_FROM_DATASET,
        onChange: () => {
          handleOptionChange(ENROLL_FROM_DATASET);
        },
        description: /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromDataset.description"
          })
        }),
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromDataset.title"
          }), /*#__PURE__*/_jsx(UIBadge, {
            className: "m-left-2",
            use: "beta",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromDataset.beta"
            })
          })]
        })
      }), /*#__PURE__*/_jsx(UIRadioInput, {
        checked: selectedOption === ENROLL_INDIVIDUAL,
        onChange: () => {
          handleOptionChange(ENROLL_INDIVIDUAL);
        },
        description: /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
            baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollIndividual.description_cob",
            objectTypeId: objectTypeId
          })
        }),
        children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
          baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollIndividual.title_cob",
          objectTypeId: objectTypeId
        })
      }), isEventBasedWorkflow && !canEnrollFromExistingTriggers && /*#__PURE__*/_jsx(UIRadioInput, {
        checked: selectedOption === ENROLL_FROM_TRIGGERS
        // TODO finish implementing onChange
        ,
        onChange: () => {
          handleOptionChange(ENROLL_FROM_TRIGGERS);
        },
        disabled: !canEnrollFromExistingTriggers,
        description: /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
            baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromTriggers.description_cob",
            objectTypeId: objectTypeId
          })
        }),
        children: /*#__PURE__*/_jsx(UITooltip, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromTriggers.disabledTooltip'
          }),
          placement: "right",
          children: /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromTriggers.title"
            }), /*#__PURE__*/_jsx(UIIcon, {
              className: "m-left-1",
              name: "dynamicFilter",
              color: EERIE,
              size: 18
            })]
          })
        })
      })]
    })
  });
};
export default ManualEnrollmentRadioOptions;